import Typography from '@mui/material/Typography';
import styled, { css } from 'styled-components';

export const UrlParser = styled(Typography)<{
  $explicitTextCursor: boolean;
  $hasPaddingRight: boolean;
  $respectNewLines: boolean;
}>`
  ${({ theme, $hasPaddingRight }) =>
    $hasPaddingRight &&
    css`
      padding-right: ${theme.spacing(2.5)};
    `};
  ${({ $explicitTextCursor }) =>
    $explicitTextCursor &&
    css`
      cursor: text;
    `};
  ${({ $respectNewLines }) =>
    $respectNewLines &&
    css`
      white-space: pre-line;
    `};
`;
